import { gql } from 'graphql-request';

export default gql`query($filter: FilterInput) {
    ledModuleType(filter: $filter) {
        id
        name
        file_path
        max_leds_per_module
        category_id
    }
}`;